import React, { useEffect, useState, useRef } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var styles = {
  "filterFieldContainer": "_jkVs9",
  "filterInputField": "_1MrOj",
  "headerTitle": "_UfOes",
  "filterOptionsList": "_2CnFw",
  "filterOptionsContainer": "_1mb06",
  "selectedFilters": "_1Q_Es",
  "filterOption": "_27yHW",
  "optionDescription": "_35TEp",
  "hovered": "__5KL1",
  "filterIcon": "_1PcK2",
  "clearIconContainer": "_1qgQW",
  "clearIcon": "_3ckMx",
  "alternateText": "_2RLFC",
  "optionsList": "_3oGlQ"
};
var UP_ARROW = 38;
var DOWN_ARROW = 40;
var ENTER_KEY = 13;
var ESCAPE_KEY = 27;

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      var el = ref === null || ref === void 0 ? void 0 : ref.current;

      if (!el || el.contains((event === null || event === void 0 ? void 0 : event.target) || null)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

var FilterIcon = function FilterIcon() {
  return React.createElement("svg", {
    "aria-hidden": 'true',
    viewBox: '0 0 16 16',
    version: '1.1',
    "data-view-component": 'true',
    height: '16',
    width: '16'
  }, React.createElement("path", {
    fillRule: 'evenodd',
    d: 'M.75 3a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H.75zM3 7.75A.75.75 0 013.75 7h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 013 7.75zm3 4a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5h-2.5a.75.75 0 01-.75-.75z'
  }));
};

var CloseIcon = function CloseIcon(_ref) {
  var className = _ref.className;
  return React.createElement("svg", {
    "aria-hidden": 'true',
    viewBox: '0 0 16 16',
    version: '1.1',
    "data-view-component": 'true',
    height: '16',
    width: '16',
    fill: 'white',
    className: className
  }, React.createElement("path", {
    fillRule: 'evenodd',
    d: 'M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z'
  }));
};

var ReactSearchableFilter = function ReactSearchableFilter(_ref) {
  var options = _ref.options,
      onSubmit = _ref.onSubmit,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Filter' : _ref$placeholder,
      className = _ref.className,
      inputClassName = _ref.inputClassName,
      dropdownListClassName = _ref.dropdownListClassName,
      customFilterIcon = _ref.customFilterIcon,
      customClearIcon = _ref.customClearIcon,
      optionsListMaxHeight = _ref.optionsListMaxHeight,
      style = _ref.style,
      hoverColor = _ref.hoverColor,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? true : _ref$editable,
      onClear = _ref.onClear;

  var _useState = useState(''),
      inputValue = _useState[0],
      setInputValue = _useState[1];

  var _useState2 = useState(false),
      showDropdown = _useState2[0],
      setShowDropdown = _useState2[1];

  var _useState3 = useState(-1),
      hoverIndex = _useState3[0],
      setHoverIndex = _useState3[1];

  var _useState4 = useState(false),
      IsOptionsPositionedTop = _useState4[0],
      setIsOptionsPositionedTop = _useState4[1];

  var defaultDropdownOptions = options.map(function (option) {
    return {
      value: option.filterBy + ':',
      description: (option === null || option === void 0 ? void 0 : option.description) || ''
    };
  });

  var _useState5 = useState(defaultDropdownOptions),
      dropdownOptions = _useState5[0],
      setDropdownOptions = _useState5[1];

  var filterFieldRef = useRef(null);
  var inputRef = useRef(null);
  var optionsContainerRef = useRef(null);
  var optionRef = useRef(null);
  var optionsMaxHeight = optionsListMaxHeight || 200;
  var optionHoverColor = hoverColor || '#0d66d6';
  var optionsListStyles = {};
  useEffect(function () {
    var _optionsContainerElem, _optionsContainerElem2;

    var optionsContainerElement = optionsContainerRef.current;
    var offsetBottom = window.innerHeight - (optionsContainerElement === null || optionsContainerElement === void 0 ? void 0 : (_optionsContainerElem = optionsContainerElement.offsetParent) === null || _optionsContainerElem === void 0 ? void 0 : _optionsContainerElem.getBoundingClientRect().top);

    if (optionsMaxHeight > offsetBottom && (optionsContainerElement === null || optionsContainerElement === void 0 ? void 0 : (_optionsContainerElem2 = optionsContainerElement.offsetParent) === null || _optionsContainerElem2 === void 0 ? void 0 : _optionsContainerElem2.getBoundingClientRect().top) > offsetBottom) {
      setIsOptionsPositionedTop(true);
    } else {
      setIsOptionsPositionedTop(false);
    }
  }, [showDropdown, optionsMaxHeight]);
  if (IsOptionsPositionedTop) optionsListStyles = {
    bottom: '100%',
    marginBottom: '5px'
  };else optionsListStyles = {
    top: '100%',
    marginTop: '5px'
  };
  var splittedInputValues = inputValue.split(' ');
  var currentFilterValue = splittedInputValues[splittedInputValues.length - 1];
  var selectedFilters = inputValue[inputValue.length - 1] === ':' ? splittedInputValues.slice(0, splittedInputValues.length - 1) : splittedInputValues;
  var filteredOptions = dropdownOptions.filter(function (option) {
    return option.value.startsWith(currentFilterValue);
  });

  var updateOptionsAsFilterValues = function updateOptionsAsFilterValues(filterByValue) {
    var _options$find;

    var filteredValuesByKey = (_options$find = options.find(function (option) {
      return option.filterBy === filterByValue;
    })) === null || _options$find === void 0 ? void 0 : _options$find.values;

    if (filteredValuesByKey) {
      setDropdownOptions(filteredValuesByKey.filter(function (value) {
        return selectedFilters.indexOf(filterByValue + ':' + value) === -1;
      }).map(function (currentFilterValue) {
        return {
          value: filterByValue + ':' + currentFilterValue,
          description: ''
        };
      }));
    }

    setHoverIndex(-1);
  };

  var updateOptionsAsFilterKeys = function updateOptionsAsFilterKeys() {
    setDropdownOptions(options.map(function (option) {
      return {
        value: option.filterBy + ':',
        description: (option === null || option === void 0 ? void 0 : option.description) || ''
      };
    }));
    setHoverIndex(-1);
  };

  var updateInputValue = function updateInputValue(e) {
    var currentInputValue = e.target.value;
    setInputValue(e.target.value);
    var splittedValues = currentInputValue.split(' ');
    var lastInputValue = splittedValues[splittedValues.length - 1];

    if (lastInputValue.includes(':')) {
      var colonIndex = lastInputValue.indexOf(':');
      updateOptionsAsFilterValues(lastInputValue.slice(0, colonIndex));
    } else {
      updateOptionsAsFilterKeys();
    }
  };

  var optionSelectHandler = function optionSelectHandler(optionValue) {
    var _inputRef$current;

    var lastSpaceCharIndex = inputValue.lastIndexOf(' ');
    var isFilterKeysAsOptions = optionValue[optionValue.length - 1] === ':';
    var valueToBeReplaced = isFilterKeysAsOptions ? optionValue : optionValue + ' ';

    if (isFilterKeysAsOptions) {
      updateOptionsAsFilterValues(optionValue.replace(':', ''));
    } else {
      updateOptionsAsFilterKeys();
    }

    if (lastSpaceCharIndex === -1) {
      setInputValue(valueToBeReplaced);
    } else {
      setInputValue(inputValue.slice(0, lastSpaceCharIndex + 1) + valueToBeReplaced);
    }

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  };

  useOnClickOutside(filterFieldRef, function () {
    setHoverIndex(-1);
    setShowDropdown(false);
  });

  var showSelectedFiltersChecker = function showSelectedFiltersChecker() {
    var isKeysAsoptions = !currentFilterValue.includes(':');
    return selectedFilters.length > 1 && isKeysAsoptions;
  };

  var submitFiltersHandler = function submitFiltersHandler() {
    setShowDropdown(false);

    if (onSubmit) {
      var filtersByKeys = [];
      selectedFilters.forEach(function (filter) {
        var _filter$split = filter.split(':'),
            key = _filter$split[0],
            value = _filter$split[1];

        var filterIndex = filtersByKeys.findIndex(function (entry) {
          return entry.filterBy === key;
        });

        if (filterIndex !== -1) {
          filtersByKeys[filterIndex].values.push(value);
        } else {
          if (key.length === 0) return;
          filtersByKeys.push({
            filterBy: key,
            values: [value]
          });
        }
      });
      onSubmit(filtersByKeys);
    }
  };

  var keyHandler = function keyHandler(e) {
    var optionsContainerElement = optionsContainerRef.current;
    var optionElement = optionRef.current;
    var optionsCount = dropdownOptions.length;

    switch (e.keyCode) {
      case UP_ARROW:
        {
          if (hoverIndex <= 0) {
            optionsContainerElement.scrollTop = optionsContainerElement.scrollHeight;

            if (hoverIndex === 0 && showSelectedFiltersChecker()) {
              setHoverIndex(-1);
            } else setHoverIndex(optionsCount - 1);
          } else {
            if (optionElement) optionsContainerElement.scrollTop = optionElement.offsetTop - optionElement.offsetHeight;
            setHoverIndex(hoverIndex - 1);
          }

          document.body.style.pointerEvents = 'none';
          break;
        }

      case DOWN_ARROW:
        {
          if (hoverIndex === optionsCount - 1) {
            optionsContainerElement.scrollTop = 0;

            if (showSelectedFiltersChecker()) {
              setHoverIndex(-1);
            } else setHoverIndex(0);
          } else {
            if (optionElement) optionsContainerElement.scrollTop = optionElement.offsetTop - optionElement.offsetHeight;
            setHoverIndex(hoverIndex + 1);
          }

          document.body.style.pointerEvents = 'none';
          break;
        }

      case ESCAPE_KEY:
        {
          var _inputRef$current2;

          setShowDropdown(false);
          inputRef === null || inputRef === void 0 ? void 0 : (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.blur();
          break;
        }

      case ENTER_KEY:
        {
          if (hoverIndex < 0) {
            if (!showSelectedFiltersChecker()) return;
            submitFiltersHandler();
          } else {
            var selectedOption = filteredOptions[hoverIndex].value;
            optionSelectHandler(selectedOption);
          }

          break;
        }
    }
  };

  var clearInputField = function clearInputField() {
    var _inputRef$current3;

    if (onClear) onClear();
    setInputValue('');
    (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.focus();
  };

  useEffect(function () {
    document.addEventListener('mousemove', function () {
      if (document.activeElement === inputRef.current) {
        document.body.style.pointerEvents = 'auto';
      }
    });
    return document.removeEventListener('mousemove', function () {
      if (document.activeElement === inputRef.current) {
        document.body.style.pointerEvents = 'auto';
      }
    });
  }, []);
  return React.createElement("div", {
    className: styles.filterFieldContainer + " " + className,
    ref: filterFieldRef,
    style: style
  }, React.createElement("div", {
    className: styles.filterIcon
  }, customFilterIcon || React.createElement(FilterIcon, null)), React.createElement("input", {
    className: styles.filterInputField + " " + inputClassName,
    onChange: updateInputValue,
    value: inputValue,
    onKeyDown: keyHandler,
    onClick: function onClick() {
      return setShowDropdown(true);
    },
    ref: inputRef,
    placeholder: placeholder,
    style: {
      cursor: editable ? 'text' : 'default'
    },
    readOnly: !editable
  }), React.createElement("div", {
    className: styles.clearIconContainer,
    onClick: clearInputField
  }, customClearIcon || React.createElement(CloseIcon, {
    className: styles.clearIcon
  })), React.createElement("div", {
    className: styles.filterOptionsContainer + " " + dropdownListClassName,
    style: _extends({
      visibility: showDropdown ? 'visible' : 'hidden',
      opacity: showDropdown ? 1 : 0
    }, optionsListStyles)
  }, React.createElement("div", {
    className: styles.optionsList,
    style: {
      maxHeight: showDropdown ? optionsMaxHeight : 0
    },
    ref: optionsContainerRef
  }, filteredOptions.length === 0 ? React.createElement("div", {
    className: styles.alternateText
  }, "Sorry no related filter available") : React.createElement("div", null, React.createElement("div", {
    className: styles.filterOptionsHeader
  }, showSelectedFiltersChecker() && React.createElement("div", {
    className: styles.selectedFilters,
    onClick: submitFiltersHandler,
    style: hoverIndex === -1 ? {
      backgroundColor: optionHoverColor
    } : {},
    onMouseEnter: function onMouseEnter() {
      return setHoverIndex(-1);
    }
  }, React.createElement("span", {
    style: {
      color: hoverIndex === -1 ? 'white' : '#6a737d'
    }
  }, selectedFilters.join(' ')), React.createElement("span", {
    style: {
      color: hoverIndex === -1 ? 'white' : '#24292E'
    }
  }, "- submit")), React.createElement("div", {
    className: styles.headerTitle
  }, "Available Filters")), React.createElement("ul", {
    className: styles.filterOptionsList
  }, filteredOptions.map(function (option, index) {
    return React.createElement("li", {
      className: styles.filterOption,
      style: hoverIndex === index ? {
        backgroundColor: optionHoverColor
      } : {},
      onClick: function onClick() {
        return optionSelectHandler(option.value);
      },
      key: option.value,
      onMouseOver: function onMouseOver() {
        return setHoverIndex(index);
      },
      ref: index === hoverIndex ? optionRef : null
    }, React.createElement("span", {
      style: {
        color: hoverIndex === index ? 'white' : '#24292E'
      }
    }, option.value), React.createElement("span", {
      className: styles.optionDescription,
      style: {
        color: hoverIndex === index ? 'white' : '#6a737d'
      }
    }, option.description));
  }))))));
};

export default ReactSearchableFilter;